/**
 * React Query hooks for Courts and Offices API
 */

import { useQuery } from '@tanstack/react-query'
import { courtsApi, Court, Office } from '../api/courts'

/**
 * Fetch all courts with codes
 * Used in Representation Court/Appellate forms
 */
export function useCourts() {
  return useQuery({
    queryKey: ['courts'],
    queryFn: () => courtsApi.getCourts(),
    staleTime: 1000 * 60 * 30, // 30 minutes - courts don't change often
  })
}

/**
 * Fetch all offices with codes
 * Used in Labor Cases forms
 */
export function useOffices() {
  return useQuery({
    queryKey: ['offices'],
    queryFn: () => courtsApi.getOffices(),
    staleTime: 1000 * 60 * 30, // 30 minutes
  })
}

/**
 * Fetch just office codes (simpler dropdown)
 */
export function useOfficeCodes() {
  return useQuery({
    queryKey: ['office-codes'],
    queryFn: () => courtsApi.getOfficeCodes(),
    staleTime: 1000 * 60 * 30, // 30 minutes
  })
}
